<template>
  <div id="app">
    <!-- 登录页 -->
    <div v-if="isLoginPage" class="login-wrapper">
      <router-view />
    </div>
    <!-- 主布局：极简白风格 -->
    <div v-else class="main-layout">
      <!-- 顶部一级导航 -->
      <div class="top-header">
        <div class="logo"><div class="dot">S</div> SCRM</div>
        <div class="main-nav">
          <div class="nav-item" :class="{active: activeNav==='home'}" @click="switchNav('home')">首页</div>
          <div class="nav-item has-dropdown" :class="{active: activeNav==='foreignTrade'}">
            外贸跨境专属
            <div class="dropdown-menu">
              <div class="dropdown-item" :class="{active: activeSubNav==='foreignTradeTwo'}" @click="switchSubNav('foreignTradeTwo', 'foreignTrade')">找老外客户</div>
              <div class="dropdown-item" :class="{active: activeSubNav==='foreignTrade'}" @click="switchSubNav('foreignTrade', 'foreignTrade')">找国内客户</div>
            </div>
          </div>
          <div class="nav-item has-dropdown" :class="{active: activeNav==='customer'}">
            企业核验线索
            <div class="dropdown-menu">
              <div class="dropdown-item" :class="{active: activeSubNav==='clue'}" @click="switchSubNav('clue', 'customer')">企业线索</div>
              <div class="dropdown-item" :class="{active: activeSubNav==='batchQuery'}" @click="switchSubNav('batchQuery', 'customer')">批量查询企业线索</div>
              <div class="dropdown-item" :class="{active: activeSubNav==='gth'}" @click="switchSubNav('gth', 'customer')">个体户企业</div>
            </div>
          </div>
          <div class="nav-item has-dropdown" :class="{active: activeNav==='group'}">
            企业人群包
            <div class="dropdown-menu">
              <div class="dropdown-item" :class="{active: activeSubNav==='taxpayer'}" @click="switchSubNav('taxpayer', 'group')">一般纳税人</div>
              <div class="dropdown-item" :class="{active: activeSubNav==='texin'}" @click="switchSubNav('texin', 'group')">专精特新企业</div>
              <div class="dropdown-item" :class="{active: activeSubNav==='taxa'}" @click="switchSubNav('taxa', 'group')">纳税A级</div>
              <div class="dropdown-item" :class="{active: activeSubNav==='selfemployee'}" @click="switchSubNav('selfemployee', 'group')">个体户银联码</div>
              <div class="dropdown-item" :class="{active: activeSubNav==='winning'}" @click="switchSubNav('winning', 'group')">中标企业</div>
            </div>
          </div>
          <div class="nav-item" :class="{active: activeNav==='custom'}" @click="switchNav('custom')">高级定制服务</div>
          <div class="nav-item" :class="{active: activeNav==='bill'}" @click="switchNav('bill')">账单</div>
        </div>
        <div class="header-right">
          <span class="balance-text">余额：<strong>{{pointInfo.point}}</strong>积分</span>
          <span class="recharge-link" @click="handleRecharge">充值</span>
          <el-dropdown trigger="click">
            <div class="user-info">
              <i class="el-icon-user-solid" style="font-size:18px;"></i>
              {{userName}}
              <i class="el-icon-arrow-down" style="font-size:11px;"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-edit" @click.native="changePwdVisible = true">修改密码</el-dropdown-item>
              <el-dropdown-item icon="el-icon-switch-button" divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- 页面标题栏 -->
      <div class="sub-header" v-if="currentPageTitle">
        <div class="current-page-title">{{ currentPageTitle }}</div>
      </div>

      <!-- 内容区域 -->
      <div class="content-area">
        <router-view />
      </div>
      <div class="app-footer">Copyright © 2023-2026 SCRM Inc.</div>

      <!-- 修改密码 -->
      <el-dialog title="修改密码" :visible.sync="changePwdVisible" width="440px" :close-on-click-modal="false">
        <el-form :model="pwdForm" label-width="80px">
          <el-form-item label="手机号"><el-input v-model="pwdForm.phone" disabled /></el-form-item>
          <el-form-item label="新密码"><el-input v-model="pwdForm.password" type="password" placeholder="新密码" /></el-form-item>
          <el-form-item label="确认密码"><el-input v-model="pwdForm.confirmedPassword" type="password" placeholder="确认密码" /></el-form-item>
          <el-form-item label="验证码">
            <div style="display:flex;gap:8px">
              <el-input v-model="pwdForm.code" placeholder="验证码" />
              <el-button @click="sendCode" :disabled="codeDisabled">{{codeText}}</el-button>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="changePwdVisible = false">取消</el-button>
          <el-button type="primary" @click="submitChangePwd">确定</el-button>
        </span>
      </el-dialog>
      <!-- 充值 -->
      <el-dialog title="充值中心" :visible.sync="rechargeVisible" width="680px" top="8vh">
        <RechargeMain @renew="refreshPoints" @close="rechargeVisible = false" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import auth from "./auth"
import RechargeMain from "@/views/recharge/RechargeMain"

// 导航路由映射
const navRouteMap = {
  home: '/home',
  customer_gth: '/gth',
  customer_clue: '/clue',
  group_taxpayer: '/personGroup',
  group_texin: '/personGroup',
  group_taxa: '/personGroup',
  group_selfemployee: '/personGroup',
  group_winning: '/personGroup',
  customer_batchQuery: '/batch-query',
  custom: '/custom-service',
  bill: '/bill',
  foreignTrade: '/foreignTrade',
  foreignTrade_foreignTrade: '/foreignTrade',
  foreignTrade_foreignTradeTwo: '/foreignTradeTwo'
}

export default {
  components: { RechargeMain },
  provide() {
    return { appNav: this }
  },
  data() {
    return {
      activeNav: 'home',
      activeSubNav: '',
      changePwdVisible: false,
      rechargeVisible: false,
      pwdForm: { phone: '', password: '', confirmedPassword: '', code: '' },
      codeText: '获取验证码',
      codeDisabled: false,
      pointInfo: { point: 0, usedPoint: 0, consumeA: 0, consumeB: 0 },
      pointInfoReady: false,
      onlineRecharge: false,
      userName: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).username || 'admin' : 'admin'
    }
  },
  computed: {
    isLoginPage() { return this.$route.path === '/login' },
    subNavItems() {
      const map = {
        customer: [{ key: 'clue', label: '企业线索' }, { key: 'batchQuery', label: '批量查询企业线索' }, { key: 'gth', label: '个体户企业' }],
        group: [{ key: 'taxpayer', label: '一般纳税人' }, { key: 'texin', label: '专精特新企业' }, { key: 'taxa', label: '纳税A级' }, { key: 'selfemployee', label: '个体户银联码' }, { key: 'winning', label: '中标企业' }],
        foreignTrade: [{ key: 'foreignTradeTwo', label: '全球搜索' }, { key: 'foreignTrade', label: '外贸人群包' }],
      }
      return map[this.activeNav] || []
    },
    currentPageTitle() {
      const map = {
        clue: '企业线索',
        batchQuery: '批量查询企业线索',
        gth: '个体户企业',
        taxpayer: '一般纳税人',
        texin: '专精特新企业',
        taxa: '纳税A级',
        selfemployee: '个体户银联码',
        winning: '中标企业',
        foreignTrade: '外贸人群包',
        foreignTradeTwo: '全球搜索',
      }
      return map[this.activeSubNav] || ''
    }
  },
  watch: {
    '$route.path'(path) {
      this.syncNavFromRoute(path)
    },
    isLoginPage(val, oldVal) {
      if (oldVal === true && !val && auth.loggedIn()) {
        this.initUserData()
      }
    }
  },
  mounted() {
    if (!this.isLoginPage && auth.loggedIn()) {
      this.initUserData()
    }
    this.syncNavFromRoute(this.$route.path)
  },
  methods: {
    syncNavFromRoute(path) {
      if (path === '/home') { this.activeNav = 'home'; this.activeSubNav = '' }
      else if (path === '/gth') { this.activeNav = 'customer'; this.activeSubNav = 'gth' }
      else if (path === '/clue') { this.activeNav = 'customer'; this.activeSubNav = 'clue' }
      else if (path === '/batch-query') { this.activeNav = 'customer'; this.activeSubNav = 'batchQuery' }
      else if (path === '/personGroup') { this.activeNav = 'group'; if (!this.activeSubNav) this.activeSubNav = 'taxpayer' }
      else if (path === '/bill') { this.activeNav = 'bill'; this.activeSubNav = '' }
      else if (path === '/custom-service') { this.activeNav = 'custom'; this.activeSubNav = '' }
      else if (path === '/foreignTrade') { this.activeNav = 'foreignTrade'; this.activeSubNav = 'foreignTrade' }
      else if (path === '/foreignTradeTwo') { this.activeNav = 'foreignTrade'; this.activeSubNav = 'foreignTradeTwo' }
    },
    switchNav(nav) {
      this.activeNav = nav
      if (nav === 'home') { this.activeSubNav = ''; this.$router.push('/home').catch(() => {}) }
      else if (nav === 'custom') { this.activeSubNav = ''; this.$router.push('/custom-service').catch(() => {}) }
      else if (nav === 'bill') { this.activeSubNav = ''; this.$router.push('/bill').catch(() => {}) }
      else if (nav === 'foreignTrade') {
        if (this.subNavItems.length > 0) {
          this.activeSubNav = this.subNavItems[0].key
          this.$router.push('/foreignTradeTwo').catch(() => {})
        }
      }
      else if (nav === 'customer') {
        if (this.subNavItems.length > 0) {
          this.activeSubNav = this.subNavItems[0].key
          this.$router.push('/clue').catch(() => {})
        }
      } else if (nav === 'group') {
        if (this.subNavItems.length > 0) {
          this.activeSubNav = this.subNavItems[0].key
          this.$router.push('/personGroup').catch(() => {})
        }
      }
    },
    switchSubNav(key, parentNav) {
      this.activeNav = parentNav
      this.activeSubNav = key
      if (parentNav === 'customer') {
        const pathMap = { clue: '/clue', gth: '/gth', batchQuery: '/batch-query' }
        const path = pathMap[key]
        if (path && this.$route.path !== path) this.$router.push(path).catch(() => {})
      } else if (parentNav === 'group') {
        if (this.$route.path !== '/personGroup') this.$router.push('/personGroup').catch(() => {})
      } else if (parentNav === 'foreignTrade') {
        const pathMap = { foreignTrade: '/foreignTrade', foreignTradeTwo: '/foreignTradeTwo' }
        const path = pathMap[key]
        if (path && this.$route.path !== path) this.$router.push(path).catch(() => {})
      }
    },
    handleRecharge() {
      if (this.onlineRecharge) {
        this.rechargeVisible = true
      } else {
        this.$message.warning('请联系客服充值')
      }
    },
    checkOnlineRecharge() {
      this.$http.sysResGetRes(3).then(r => {
        if (r.data && r.data.content1 === '1') this.onlineRecharge = true
      }).catch(() => {})
    },
    logout() {
      auth.logOut()
      this.$router.push('/login')
    },
    initUserData() {
      this.refreshPoints()
      this.getBindPhone()
      this.checkOnlineRecharge()
      let token = localStorage.getItem("token")
      if (token) this.$websocket.initWebSocket(token)
    },
    refreshPoints() {
      this.$http.getPointCountView().then(r => { if (r.data) { this.pointInfo = r.data; this.pointInfoReady = true } })
    },
    getBindPhone() {
      this.$http.getBindPhone().then(r => { if (r.data) this.pwdForm.phone = r.data })
    },
    sendCode() {
      if (!this.pwdForm.phone) { this.$message.error('手机号不存在'); return }
      this.$http.getCode({ phone: this.pwdForm.phone }).then(r => {
        if (r.status === 'success') {
          this.$message.success(r.msg)
          this.codeDisabled = true
          let sec = 60
          const timer = setInterval(() => { sec--; this.codeText = sec + 's后重试'; if (sec <= 0) { clearInterval(timer); this.codeText = '获取验证码'; this.codeDisabled = false } }, 1000)
        } else { this.$message.error(r.msg) }
      })
    },
    submitChangePwd() {
      if (!this.pwdForm.password) { this.$message.error('请输入密码'); return }
      if (this.pwdForm.password !== this.pwdForm.confirmedPassword) { this.$message.error('两次密码不一致'); return }
      if (!this.pwdForm.code) { this.$message.error('请输入验证码'); return }
      this.$http.updatePassword(this.pwdForm).then(r => {
        if (r.status === 'success') {
          this.$message.success('密码修改成功，请重新登录')
          this.changePwdVisible = false
          this.logout()
        } else { this.$message.error(r.msg) }
      })
    }
  }
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
html, body, #app { height: 100%; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif; background: #f7f8fa; }

/* 登录页 */
.login-wrapper { height: 100vh; }

/* 主布局 */
.main-layout { display: flex; flex-direction: column; height: 100vh; }

/* 顶部栏 */
.top-header { height: 56px; background: #fff; display: flex; align-items: center; padding: 0 32px; border-bottom: 1px solid #e8e8e8; flex-shrink: 0; z-index: 10; }
.top-header .logo { font-size: 20px; font-weight: 700; color: #303133; margin-right: 40px; display: flex; align-items: center; gap: 8px; }
.top-header .logo .dot { width: 28px; height: 28px; border-radius: 8px; background: #409eff; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 800; }
.top-header .main-nav { display: flex; gap: 4px; flex: 1; }
.top-header .main-nav .nav-item { padding: 8px 18px; border-radius: 6px; font-size: 14px; color: #606266; cursor: pointer; transition: all 0.15s; position: relative; }
.top-header .main-nav .nav-item:hover { color: #409eff; background: #f0f7ff; }
.top-header .main-nav .nav-item.active { color: #409eff; font-weight: 600; background: #f0f7ff; }

.top-header .main-nav .nav-item .dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-radius: 6px;
  padding: 6px 0;
  min-width: 160px;
  z-index: 100;
}
.top-header .main-nav .nav-item.has-dropdown::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  height: 4px;
  background: transparent;
  z-index: 101;
}
.top-header .main-nav .nav-item.has-dropdown:hover .dropdown-menu,
.top-header .main-nav .nav-item .dropdown-menu:hover {
  display: block;
}

.dropdown-item {
  padding: 8px 16px;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.dropdown-item:hover,
.dropdown-item.active {
  color: #409eff;
  background: #f0f7ff;
}

.top-header .header-right { display: flex; align-items: center; gap: 16px; }
.top-header .balance-text { font-size: 13px; color: #909399; }
.top-header .balance-text strong { color: #409eff; font-size: 16px; margin: 0 2px; }
.top-header .recharge-link { color: #409eff; font-size: 13px; cursor: pointer; font-weight: 500; }
.top-header .recharge-link:hover { text-decoration: underline; }
.top-header .user-info { display: flex; align-items: center; gap: 6px; cursor: pointer; color: #606266; font-size: 13px; }

/* 页面标题栏 */
.sub-header { height: 44px; background: #e8f0fe; display: flex; align-items: center; padding: 0 32px; border-bottom: 1px solid #c9d8eb; flex-shrink: 0; }
.sub-header .current-page-title { font-size: 16px; font-weight: 700; color: #303133; }

/* 内容区域 */
.content-area { flex: 1; overflow-y: auto; padding: 24px 32px; }

/* 底部 */
.app-footer { text-align: center; padding: 14px; color: #dcdfe6; font-size: 12px; flex-shrink: 0; }

/* 全局弹窗圆角 */
.el-dialog { border-radius: 12px !important; }
.el-dialog__header { border-bottom: 1px solid #f0f0f0; padding-bottom: 16px !important; }
.el-dialog__footer { border-top: 1px solid #f0f0f0; padding-top: 16px !important; }
</style>
